/**
* @adobe/react-spectrum-workflow (c) by Adobe
* 
* @adobe/react-spectrum-workflow is licensed under a
* Creative Commons Attribution-NoDerivatives 4.0 International License.
* 
* You should have received a copy of the license along with this
* work. If not, see <http://creativecommons.org/licenses/by-nd/4.0/>.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uLight = A4uLight;

var _react = _interopRequireDefault(require("react"));

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function A4uLight(_ref) {
  var _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 'M' : _ref$scale,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'LIGHT' : _ref$color,
      props = _objectWithoutProperties(_ref, ["scale", "color"]);

  return _react["default"].createElement("svg", _extends({
    viewBox: _util.viewBoxes[scale]
  }, props, props), _react["default"].createElement("circle", {
    cx: 18,
    cy: 18,
    r: 7.9
  }), _react["default"].createElement("rect", {
    height: 6,
    rx: 0.5,
    ry: 0.5,
    width: 3.6,
    x: 16.2
  }), _react["default"].createElement("rect", {
    height: 6,
    rx: 0.5,
    ry: 0.5,
    width: 3.6,
    x: 16.2,
    y: 30
  }), _react["default"].createElement("rect", {
    height: 3.6,
    rx: 0.5,
    ry: 0.5,
    width: 6,
    y: 16.2
  }), _react["default"].createElement("rect", {
    height: 3.6,
    rx: 0.5,
    ry: 0.5,
    width: 6,
    x: 30,
    y: 16.2
  }), _react["default"].createElement("rect", {
    height: 3.6,
    rx: 0.5,
    ry: 0.5,
    transform: "rotate(-45 29.02 7.02)",
    width: 6,
    x: 26.02,
    y: 5.22
  }), _react["default"].createElement("rect", {
    height: 3.6,
    rx: 0.5,
    ry: 0.5,
    transform: "rotate(-45 7.02 29.02)",
    width: 6,
    x: 4.02,
    y: 27.22
  }), _react["default"].createElement("rect", {
    height: 6,
    rx: 0.5,
    ry: 0.5,
    transform: "rotate(-45 7 7)",
    width: 3.6,
    x: 5.2,
    y: 4
  }), _react["default"].createElement("rect", {
    height: 6,
    rx: 0.5,
    ry: 0.5,
    transform: "rotate(-45 28.98 28.98)",
    width: 3.6,
    x: 27.18,
    y: 25.98
  }));
}